import { doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { ProductConfigurations } from "../types";

export type ProductToUpdateParams = {
  studioId: string;
  productId: string;
  productConfigs: ProductConfigurations;
};

export const updateProductConfigsByStudioId = async ({
  studioId,
  productConfigs,
  productId,
}: ProductToUpdateParams): Promise<void> => {
  const productRef = doc(db, `studios/${studioId}/products/${productId}`);

  return await updateDoc(productRef, { configurations: productConfigs });
};
